import { __rest } from "tslib";
import { jsx as _jsx } from "react/jsx-runtime";
import { observer } from 'mobx-react';
import * as React from 'react';
import { Stack, cn } from '@marvelapp/ballpark-components';
export const ListWrapper = observer(function ListWrapper(_a) {
    var { children } = _a, props = __rest(_a, ["children"]);
    return (_jsx(Stack, Object.assign({ className: cn('max-h-full w-full flex-1 overflow-y-scroll p-2'), direction: "col", gap: "px" }, props, { children: children })));
});
